import { useTranslation } from "react-i18next";
import "./App.css";

import { useEffect } from "react";

import { Route, Routes } from "react-router-dom";

import Dashboard from "./Components/dashboard/DashboardLayout.js";
import DashboardProducts from "./Components/dashboard/DashboardProducts.js";
import DashboardOrders from "./Components/dashboard/DashboardOrders.js";
import DashboardReviews from "./Components/dashboard/DashboardReviews.js";
import AddProductForm from "./Components/dashboard/AddProduct.js";
import EditProductForm from "./Components/dashboard/EditProductForm.js";
import EditReview from "./Components/dashboard/EditReview.js";
import AddReview from "./Components/dashboard/AddReview.js";
import CityManager from "./Components/dashboard/CityManager.js";
import CategoryManager from "./Components/dashboard/CategoryManager.js";
import ProductDetails from "./Components/ProductDetails";
import Login from "./Components/Login.js";
import Unauthorized from "./Components/Unauthorized.js";
import ProtectedRoute from "./ProtectedRoute.js";
import NotFound from "./Components/dashboard/NotFound.js";

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.dir = i18n.language === "ar" ? "rtl" : "ltr";
  }, [i18n.language]);

  return (
    <div className="App">
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/unauthorized" element={<Unauthorized />} />

        {/* Protected Routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        >
          <Route path="products/:id" element={<ProductDetails />} />
          <Route path="products" element={<DashboardProducts />} />
          <Route path="orders" element={<DashboardOrders />} />
          <Route path="reviews" element={<DashboardReviews />} />
          <Route path="addProduct" element={<AddProductForm />} />
          <Route path="products/:id/edit" element={<EditProductForm />} />
          <Route path="reviews/edit/:id" element={<EditReview />} />
          <Route path="addReview" element={<AddReview />} />
          <Route path="categories" element={<CategoryManager />} />
          <Route path="cities" element={<CityManager />} />
        </Route>

        {/* Catch-all 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;
